/**
 * The reading the OEM data action opens from an InfoBubble: a Trail bubble
 * shows that trail point (`vehicleTrail.id` is its rowId; while the bubble
 * still shows its click-time preview, `unit.id` is the trail point id, so the
 * caller passes the unit id it requested), a Vehicle bubble the unit's latest
 * reading.
 */
export const getOemDataTarget = (type, data, trailUnitId) => {
	const unit = data?.markerDetail?.unit;
	if (type === 'Trail') {
		const trail = data?.markerDetail?.vehicleTrail;
		return { unitId: trailUnitId || trail?.deviceId, eventId: trail?.id };
	}
	return { unitId: unit?.id, eventId: unit?.lastReading?.rowId };
};
